import type { SchemaVersions } from '@contentful/experiences-core/types';

// this is the array of version which currently LATEST_SCHEMA_VERSION is compatible with
export const compatibleVersions: SchemaVersions[] = ['2023-09-28'];

export { SDK_VERSION } from './sdkVersion';
